import CityPageTemplate from "../city-template/CityPageTemplate";
import { kirklandConfig } from "./data";

export default function KirklandPage() {
  return <CityPageTemplate config={kirklandConfig} />;
}